// Libellés partagés des demandes d'assurance auto (PER-2210 / PER-2208).
// Source unique : la page « Demandes en cours » (AUTORequestCard) et le cadre
// de l'accueil (AUTORequestsSummary) doivent afficher exactement les mêmes
// formules et les mêmes statuts — les dupliquer les ferait diverger.

export const FORMULES = {
  serenite: "Sérénité",
  confort: "Confort",
  essentiel: "Essentiel",
};

// `step` : position dans le stepper 4 étapes de la page Demandes en cours.
export const STATUS = {
  RECEIVED: { label: "Reçue", badge: "auto-badge-received", step: 1 },
  UNDER_REVIEW: {
    label: "En cours d'étude",
    badge: "auto-badge-progress",
    step: 2,
  },
  QUOTE_AVAILABLE: {
    label: "Devis disponible",
    badge: "auto-badge-ready",
    step: 3,
  },
};

export const STEPS = ["Reçue", "En cours d'étude", "Devis disponible", "Terminée"];

// Statut inconnu (nouveau code côté API) : on retombe sur « Reçue » plutôt que
// de casser l'affichage.
export const getStatus = (status) => STATUS[status] || STATUS.RECEIVED;

// « Audi Q3 » — libellé du véhicule, avec repli quand la marque et le modèle
// manquent tous les deux.
export const getVehicleLabel = (vehicle) =>
  [vehicle?.make, vehicle?.model].filter(Boolean).join(" ");
